<template>
  <div class="BWSelect">
    <van-field
      readonly
      clickable
      :label="label"
      :value="text"
      :placeholder="placeholder"
      right-icon="arrow"
      @click="showTermPicker = true"
    />
    <van-popup v-model="showTermPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columnsTerm"
        @cancel="showTermPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
     <div class="line">
    </div>
  </div>
</template>

<script>
export default {
  name: 'BWSelect',
  props: ['label', 'placeholder', 'columnsTerm', 'value'],
  data() {
    return {
      showTermPicker: false,
      text: '',
    };
  },
  watch: {
    value: {
      handler(val) {
        console.log(val, this.columnsTerm);
        if (val) {
          // eslint-disable-next-line no-nested-ternary
          this.text = this.columnsTerm.length > 0
            ? this.columnsTerm.filter((e) => e.value === val).length > 0 ? this.columnsTerm.filter((e) => e.value === val)[0].text : ''
            : '';
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    onConfirm(obj) {
      this.$emit('input', obj.value);
      this.showTermPicker = false;
    },
  },
};
</script>
<style scoped>
.BWSelect{
  position: relative;
}
.van-field__label {
  text-align: left;
  width: 80px;
}
.line::after {
  position: absolute;
  right: 16px;
  bottom: 0;
  left: 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #dddee1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: " ";
  pointer-events: none;
}
.van-picker__cancel,
.van-picker__confirm {
  color: #ff6538;
}
</style>
